<div class="container mt-lg-5 mt-2">
  <form class="col-12 col-lg-10 offset-lg-1 px-lg-5 d-flex flex-column" [formGroup]="form" (ngSubmit)="onSubmit()">
    <h1 class="text-center">You're eligible for virtual primary care through your employer.</h1>
    <p class="text-center mb-3">
      We don't currently have offices in your area but the good news is that you're eligible for scheduled virtual
      primary care through your employer coverage! You also have access to 24/7 care over video chat and asynchronous
      messaging in our app.
    </p>
    <div class="col-12 col-md-8 offset-md-2">
      <div class="mt-3">
        <om-submit-button
          class="col-12"
          label="Continue as Virtual Member"
          [submitting]="submitting"
        ></om-submit-button>
      </div>
      <div class="mt-4">
        <p class="text-center mb-5 mb-xl-5">
          If you live near a One Medical office, please contact your employer's benefits team to confirm the address on
          file reflects your current address.
        </p>
      </div>
    </div>
  </form>
</div>
